import { createFileRoute } from "@tanstack/react-router"

import { Button } from "../components/Button.tsx"
import * as Auth from "../lib/auth.ts"
import { rpc } from "../lib/rpc.ts"

export const Route = createFileRoute("/")({
  component: RouteComponent,
})

function RouteComponent() {
  const { data: authData } = Auth.useAuthData()
  if (!authData)
    return (
      <div className="p-4">
        {/** TODO: landing page */}
        <Button
          render={
            <a href={Auth.url()}>
              <OcticonMarkGithub16 />
              <div>Continue with GitHub</div>
            </a>
          }
        />
      </div>
    )

  return (
    <div>
      <div className="flex gap-2 p-4">
        <Button
          render={
            <a href={rpc.app.installations.new.$url().href}>
              <OcticonMarkGithub16 />
              <div>Install on GitHub</div>
            </a>
          }
        />

        <Button onClick={() => Auth.logout()} type="button">
          Sign out
        </Button>
      </div>
    </div>
  )
}
